import React, { useState } from 'react';
import { Container, Typography, Paper, Box, List, ListItem, ListItemIcon, ListItemText, Divider, Grid, Button } from '@mui/material';
import SensorDoorIcon from '@mui/icons-material/SensorDoor';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import SensorsIcon from '@mui/icons-material/Sensors';
import SecurityIcon from '@mui/icons-material/Security';
import DoorFrontIcon from '@mui/icons-material/DoorFront';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PersonIcon from '@mui/icons-material/Person';
import ManDoorSysOpening from '../user_manuals/images/ManDoorSysOpening.jpg';
import ManDoorSysDrive from '../user_manuals/images/ManDoorSysDrive.jpg';
import ManDoorSysClosing from '../user_manuals/images/ManDoorSysClosing.jpg';
import RedButton from '../user_manuals/images/RedButton.jpg';
import ManOpen from '../user_manuals/images/ManOpen.jpg';
import ManClose from '../user_manuals/images/ManClose.jpg';
import DoorSlidingOutlinedIcon from '@mui/icons-material/DoorSlidingOutlined';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

const imageStyle = {
  width: '100%',
  maxWidth: 180,
  borderRadius: 8,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  marginBottom: 8,
};

const Door_System = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [openClosePopup, setOpenClosePopup] = useState(false);
  const [openObstaclePopup, setOpenObstaclePopup] = useState(false);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            Automatisches Türsystem im MAN Bus
          </Typography>
        </Box>
        {/* Neue Sektion: Übersicht Türsystem – Aktionen und Status */}
        <Box sx={{ my: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            
            Aktionen und Status
          </Typography>
          <table style={{ width: '100%', borderCollapse: 'collapse', background: '#f9f9f9' }}>
            <tbody>
              <tr
                style={{ borderBottom: '1px solid #ddd', cursor: 'pointer' }}
                onClick={() => setOpenPopup(true)}
              >
                <td style={{ padding: 12, textAlign: 'center' }}>
                  <img src={ManOpen} alt="Knopf öffnen" style={{ width: 65, verticalAlign: 'middle', m: '0px' }} />
                </td>
                <td style={{ padding: 12, textAlign: 'center' }}>
                  <DoubleArrowIcon color="primary" sx={{ fontSize: 28, mx: 0, transform: 'scaleX(-1)' }} />
                  <DoubleArrowIcon color="primary" sx={{ fontSize: 28, mx: 0 }} />                  
                </td>
                <td style={{ padding: 12, textAlign: 'center' }}>
                  <TouchAppIcon color="primary" sx={{ fontSize: 32 }} />
                  <EmojiPeopleIcon color="primary" sx={{ fontSize: 32 }} />
                </td>
              </tr>
              <tr
                style={{ borderBottom: '1px solid #ddd', cursor: 'pointer' }}
                onClick={() => setOpenClosePopup(true)}
              >
                <td style={{ padding: 12, textAlign: 'center' }}>
                  <img src={ManClose} alt="Knopf schließen" style={{ width: 70, verticalAlign: 'middle', margin: '0px' }} />
                </td>
                <td style={{ padding: 12, textAlign: 'center', fontWeight: 'bold' }}>
                  <DoubleArrowIcon color="primary" sx={{ fontSize: 28, mx: 0 }} />
                  <DoubleArrowIcon color="primary" sx={{ fontSize: 28, mx: 0, transform: 'scaleX(-1)' }} />
                </td>
                <td style={{ padding: 12, textAlign: 'center' }}>
                  <DoorSlidingOutlinedIcon color="primary" sx={{ fontSize: 32 }} />
                </td>
              </tr>
              <tr
                style={{ borderBottom: '1px solid #ddd', cursor: 'pointer' }}
                onClick={() => setOpenObstaclePopup(true)}
              >
                <td style={{ padding: 12, textAlign: 'center' }}>
                  <SensorOccupiedIcon color="error" sx={{ fontSize: 32, verticalAlign: 'middle' }} />
                </td>
                <td style={{ padding: 12, textAlign: 'center' }}>
                  <img src={ManOpen} alt="Knopf öffnen" style={{ width: 70, verticalAlign: 'middle', margin: '0px' }} />
                </td>
                <td style={{ padding: 12, textAlign: 'center' }}>
                  <img src={ManClose} alt="Knopf schließen" style={{ width: 70, verticalAlign: 'middle', margin: '0px' }} />
                </td>
              </tr>
            </tbody>
          </table>
          {/* Popup for Tür ist freigegeben */}
          {openPopup && (
            <Box
              sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                bgcolor: 'rgba(0,0,0,0.3)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={() => setOpenPopup(false)}
            >
              <Paper sx={{ p: 4, minWidth: 320, textAlign: 'center' }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                  Tür ist freigegeben
                </Typography>
                <Typography variant="body1">
                  Die Tür ist jetzt für die Fahrgäste freigegeben und kann selbstständig geöffnet werden.
                </Typography>
                <Box sx={{ mt: 3 }}>
                  <Button variant="contained" onClick={() => setOpenPopup(false)}>
                    Schließen
                  </Button>
                </Box>
              </Paper>
            </Box>
          )}
          {/* Popup for Schließvorgang gestartet */}
          {openClosePopup && (
            <Box
              sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                bgcolor: 'rgba(0,0,0,0.3)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={() => setOpenClosePopup(false)}
            >
              <Paper sx={{ p: 4, minWidth: 320, textAlign: 'center' }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                  Schließvorgang gestartet
                </Typography>
                <Typography variant="body1">
                  Die Türen werden jetzt geschlossen. Bitte achten Sie darauf, dass sich keine Fahrgäste im Türbereich befinden.<br /><br />
                  Falls ein Hindernis erkannt wird, wird die Tür geöffnet.<br />
                  Nach erfolgreichem Schließen der Türen kann der Bus die Haltestelle verlassen.
                </Typography>
                <Box sx={{ mt: 3 }}>
                  <Button variant="contained" onClick={() => setOpenClosePopup(false)}>
                    Schließen
                  </Button>
                </Box>
              </Paper>
            </Box>
          )}
          {/* Popup for Türblockierung / Hindernis erkannt */}
          {openObstaclePopup && (
            <Box
              sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                bgcolor: 'rgba(0,0,0,0.3)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={() => setOpenObstaclePopup(false)}
            >
              <Paper sx={{ p: 4, minWidth: 320, textAlign: 'center' }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                  Türblockierung / Hindernis erkannt
                </Typography>
                <Typography variant="body1">
                  Wenn während des Schließvorgangs ein Hindernis, z.B. eine Person oder ein Rucksack, erkannt wird, wird der Schließvorgang gestoppt.<br /><br />
                  Der Fahrer muss dann erneut den Öffnungsknopf und anschließend den Schließknopf betätigen.
                </Typography>
                <Box sx={{ mt: 3 }}>
                  <Button variant="contained" onClick={() => setOpenObstaclePopup(false)}>
                    Schließen
                  </Button>
                </Box>
              </Paper>
            </Box>
          )}
        </Box>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Moderne MAN Linienbusse sind mit einem automatischen Türsystem ausgestattet, das den Fahrgästen ein sicheres und komfortables Ein- und Aussteigen ermöglicht. Die Türen werden nicht mehr ausschließlich vom Fahrer geöffnet, sondern können von den Fahrgästen selbstständig bedient werden.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <List>
          <ListItem>
            <ListItemIcon>
              <TouchAppIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Selbstständiges Öffnen der Türen"
              secondary="Fahrgäste können die Türen sowohl von innen als auch von außen durch das Drücken der Türöffnungsknöpfe öffnen. Dies erhöht die Flexibilität und den Komfort beim Ein- und Aussteigen."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <SensorsIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Sicherheits-Sensoren"
              secondary="Die Türen sind mit Sensoren ausgestattet, die erkennen, ob sich Personen im Türbereich befinden. Dadurch wird verhindert, dass die Türen schließen, solange sich Fahrgäste beim Ein- oder Aussteigen im Gefahrenbereich befinden."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <SecurityIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Verletzungsschutz"
              secondary="Das System sorgt dafür, dass die Türen bei Widerstand sofort stoppen und wieder öffnen, um Verletzungen zu vermeiden. Dies gilt sowohl beim Einsteigen als auch beim Aussteigen."
            />
          </ListItem>
        </List>
        <Divider sx={{ my: 2 }} />

        {/* Neue Sektion: Fotos und Anleitungen */}
        <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 3, mb: 2 }}>
          Bedienung des Türsystems – Schritt für Schritt
        </Typography>
        <Grid container spacing={3}>
          {/* Erste Reihe: Öffnen */}
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: 'center' }}>
              <LockOpenIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <img src={ManDoorSysOpening} alt="Tür öffnen" style={imageStyle} />
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                Türöffnung
              </Typography>
              <Typography variant="body2">
                Mit diesem Knopf wird das Türsystem freigegeben und die Fahrgäste können die Türen selbstständig öffnen.
              </Typography>
            </Box>
          </Grid>
          {/* Zweite Reihe: Schließen */}
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: 'center' }}>
              <LockIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <img src={ManDoorSysClosing} alt="Tür schließen" style={imageStyle} />
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                Türschließen
              </Typography>
              <Typography variant="body2">
                Mit diesem Knopf wird der Schließvorgang der Türen eingeleitet.
              </Typography>
            </Box>
          </Grid>
          {/* Dritte Reihe: Abfahrt */}
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: 'center' }}>
              <DirectionsBusIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <img src={ManDoorSysDrive} alt="Abfahrt" style={imageStyle} />
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                Abfahrt
              </Typography>
              <Typography variant="body2">
                Die Türen sind geschlossen, das Fahrzeug kann sicher vom Haltestellenbereich abfahren.
              </Typography>
            </Box>
          </Grid>
          {/* Vierte Reihe: Sensor ausgelöst */}
          <Grid item xs={12} md={12}>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <BlockIcon color="error" sx={{ fontSize: 40, mb: 1 }} />
              <img src={RedButton } alt="Sensor ausgelöst" style={imageStyle} />
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                Sensor ausgelöst / Türblockierung 
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }} color='error'>
                Der rote, runde Knopf ist beleuchtet.
              </Typography>
              <Typography variant="body2" sx={{ mt: 2, fontSize: 16, lineHeight: 1.8 }}>
                Ein Fahrgast hat den Sensor ausgelöst und die Türen haben sich aus Sicherheitsgründen wieder geöffnet.<br />
                In diesem Fall muss der Fahrer erneut den Öffnungsknopf&nbsp;
                <img src={ManOpen} alt="Knopf öffnen" style={{ width: 48, verticalAlign: 'middle', margin: '1px 4px' }} />
                und anschließend den Schließknopf&nbsp;
                <img src={ManClose} alt="Knopf schließen" style={{ width: 48, verticalAlign: 'middle', margin: '1px 4px' }} />
                betätigen.<br />
                Der Knopf mit dem Kinderwagen-Symbol blockiert den Schließvorgang der Türen nicht.
              </Typography>
              
            </Box>
          </Grid>
        </Grid>

        
      </Paper>
    </Container>
  );
};

export default Door_System;